// lib
import { connect } from "react-redux";
// src
import Component from "components/modals/search/Search";
import { clearSearch } from "actions/search";
import { fetchSearch } from "actions/search/thunks";
import { manageAddToLocals } from "actions/presets/thunks";
import { hideSearch } from "actions/ux";
import { selfTranslate } from "i18n/proxy";

const mapStateToProps = ({ search: { results }, ux: { isSearchOpen, isSmall, language } }) => ({
  isSearchOpen,
  isSmall,
  results,
  selfTranslate: (name) => selfTranslate(name, language),
});

const mapDispatchToProps = {
  manageAddToLocals,
  fetchSearch,
  clearSearch,
  hideSearch,
};

export default connect(mapStateToProps, mapDispatchToProps)(Component);
